import Text from '../Text';
import Icon from '../Icon';
import TIcon from '../TIcon';

const Button = ({
    children = null,
    text = null,
    iconName = null,
    tIconName = null,
    overflow = "overflow-hidden",
    buttonColor = "bg-transparent",
    buttonClickClass = "active:bg-slate-100",
    classNames = "",
    itemPosition = "items-center justify-center",
    onClickAction = null,
    iconSize = 24,
    textType = "buttontext",
    borderStyle = "border rounded-lg border-gray-300",
    type = "button",
    textClasses = "",
    value = null,
    style = null,
    disabled = false,
    tIconColor ="black" }) => {
    return (
        <button
            onClick={onClickAction}
            className={`p-1 flex ${itemPosition} ${overflow} ${buttonColor} ${ disabled ? '' : buttonClickClass} ${classNames} ${borderStyle}`}
            type={type}
            disabled={disabled}
            value={value}
            style={style}
        >
            {children}

            {/* Render TablerIcon if given */}
            {tIconName && <div className='h-full flex justify-center items-center '><TIcon name={tIconName} classNames='h-fit w-fit' size={iconSize} color={tIconColor} /></div>}

            {/* Render Text if given */}
            {text && <Text classNames={textClasses} type={textType}>{text}</Text>}

            {/* Render SVG if given */}
            {iconName && <div className={`h-full w-full flex ${itemPosition}`}><Icon iconName={iconName} classNames='h-full' /></div>}
        </button>
    )
}
export default Button